/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-music
 * Generated: 2026-06-06T02:49:35.308Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 57 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const musicWords = [
    {
        "word": "PIANO"
    },
    {
        "word": "GUITAR"
    },
    {
        "word": "FIDDLE"
    },
    {
        "word": "HARP"
    },
    {
        "word": "DRUM"
    },
    {
        "word": "FLUTE"
    },
    {
        "word": "BANJO"
    },
    {
        "word": "CELLO"
    },
    {
        "word": "ORGAN"
    },
    {
        "word": "TRUMPET"
    },
    {
        "word": "OBOE"
    },
    {
        "word": "VIOLIN"
    },
    {
        "word": "MOZART"
    },
    {
        "word": "CHOPIN"
    },
    {
        "word": "BRAHMS"
    },
    {
        "word": "HAYDN"
    },
    {
        "word": "STRAUSS"
    },
    {
        "word": "GERSHWIN"
    },
    {
        "word": "SOUSA"
    },
    {
        "word": "COPLAND"
    },
    {
        "word": "JAZZ"
    },
    {
        "word": "SWING"
    },
    {
        "word": "RAGTIME"
    },
    {
        "word": "BALLAD"
    },
    {
        "word": "GOSPEL"
    },
    {
        "word": "HYMN"
    },
    {
        "word": "BLUES"
    },
    {
        "word": "FOLK"
    },
    {
        "word": "COUNTRY"
    },
    {
        "word": "OPERA"
    },
    {
        "word": "RHYTHM"
    },
    {
        "word": "MELODY"
    },
    {
        "word": "CHORD"
    },
    {
        "word": "TEMPO"
    },
    {
        "word": "ENCORE"
    },
    {
        "word": "CHOIR"
    },
    {
        "word": "OCTAVE"
    },
    {
        "word": "LYRIC"
    },
    {
        "word": "REFRAIN"
    },
    {
        "word": "TENOR"
    },
    {
        "word": "ALTO"
    },
    {
        "word": "BASS"
    },
    {
        "word": "DUET"
    },
    {
        "word": "SCORE"
    },
    {
        "word": "CONCERT"
    },
    {
        "word": "SONG"
    },
    {
        "word": "SING"
    },
    {
        "word": "VERSE"
    },
    {
        "word": "DISCO"
    },
    {
        "word": "ROCK"
    },
    {
        "word": "BAND"
    },
    {
        "word": "SOLO"
    },
    {
        "word": "OPERA"
    },
    {
        "word": "ORCHESTRA"
    },
    {
        "word": "CLASSIC"
    },
    {
        "word": "DANCE"
    },
    {
        "word": "TUNE"
    }
];
//# sourceMappingURL=music.js.map